import type { EmberToolCallCreatedEvent, EmberToolCallDeltaEvent } from '@/src/api/types/generated-types'
import { useSocketIoListener } from '@/src/hooks/useSocketIoListener.hook'

type ToolHandlingCustomActions = {
  onToolCallCreated?: (event: EmberToolCallCreatedEvent) => void
  onToolCallDelta?: (event: EmberToolCallDeltaEvent) => void
}

export const useEmberToolCallHandling = (customActions: ToolHandlingCustomActions = {}) => {
  const handleToolCallCreated = (event: EmberToolCallCreatedEvent) => {
    if (event.eventName !== 'toolCallCreated') return
    customActions.onToolCallCreated?.(event)
  }

  const handleToolCallDelta = (event: EmberToolCallDeltaEvent) => {
    if (event.eventName !== 'toolCallDelta') return
    customActions.onToolCallDelta?.(event)
  }

  // Socket listeners
  useSocketIoListener('emberChat.toolCallCreated', handleToolCallCreated)
  useSocketIoListener('emberChat.toolCallDelta', handleToolCallDelta)
}
